"use client";

import Image from "next/image";
import useCartStore from "@/store/cartStore";
import Link from "next/link";

export default function ProductCartComponent() {
  const { cart } = useCartStore();
  return (
    <>
      {cart.length > 0 && (
        <div className="flex justify-between items-center">
          <div className="flex items-center">
            {/* <div className={`h-12 w-12 relative ${cart.length>1?'border rounded-lg bg-white':''}`}>
                        <Image src="https://static.curlified.in/assets/gallery/ed266549-eac9-4feb-98b3-7d93ffb31df3.png" alt="cart" width={24} height={24} className="last:absolute last:z-[1] h-12 w-12 last:bg-white last:top-0 last:left-[10px] last:rounded last:border" />
                    </div> */}
            <div className="ml-5">
              <p className="text-sm font-bold text-[#6B4322]">
                {cart.length} items
              </p>
              {/* <span className='text-[#00AD65] font-semibold text-xs'>You save Rs. 5465</span> */}
            </div>
          </div>
          <div>
            <Link
              href="/mycart"
              className="p-3 inline-block bg-[#6B4322] text-white text-sm font-semibold rounded-md shadow hover:bg-[#54351a] transition"
            >
              VIEW CART
            </Link>
          </div>
        </div>
      )}
    </>
  );
}
